import { EditOutlined, EyeOutlined, SwapOutlined } from '@ant-design/icons';
import { Button, Result } from 'antd';
import React from "react";
import { Link, useOutletContext, useRouteLoaderData } from 'react-router-dom';
import { generateRouteUrl } from '../../../library/constants';
import style from './proof-rejected.module.scss';


const ProofRejectedByCustomer = () => {
    const { orderDetails } = useRouteLoaderData('OrderManagerDetailsPage')
    const { getClientArtworks } = useOutletContext()
    return (
        <div className={style.container}>
            <Result
                status="warning"
                title="Proof has been rejected by customer."
                subTitle={orderDetails.comments?.client_proof_rejected}
                extra={[
                    <Button key="ViewArtwork" className={style.greenButton} icon={<EyeOutlined />} onClick={getClientArtworks}>View Artwork</Button>,
                    <Link key="CustomerArtworkToVendor" to={generateRouteUrl('ProofReRequestVedor', {
                        itemId: orderDetails.id,
                    })}>
                        <Button className={style.greenButton} icon={<SwapOutlined />}>Re - Request Proof from Vendor</Button>
                    </Link>,
                    <Link key="UpdateProof" to={generateRouteUrl('UpdateProof', {
                        itemId: orderDetails.id,
                    })}>
                        <Button className={style.greenButton} icon={<EditOutlined />}>Update Existing Proof</Button>
                    </Link>
                ]}
            />
        </div>
    )
}


export default ProofRejectedByCustomer;